export const StatusGroup = {
	answered: 'ANSWERED',
	new: 'NEW',
	work: 'WORK',
};
